import React from 'react';
import dayjs from 'dayjs';
import Iconify from '../Iconify';
import Skeleton from '@mui/material/Skeleton';
import { FormatDate } from '../../utils/formatDate';
import ContractRenewStatus from './contractRenewStatus';
import { Box, Typography, Tooltip } from '@mui/material';

const ContractsListViewData = ({ contract, handleContractClick, columnWidth }) => {

    const machinesMap = new Map();
    // Loop through each contract in contract_date
    contract.contract_date.forEach(contract => {
        // Check if contract_machine exists and is an array
        if (contract.contract_machine && Array.isArray(contract.contract_machine)) {
            // Loop through each machine in contract_machine
            contract.contract_machine.forEach(cm => {
                // Add to map if machine exists and isn't already added
                if (cm.machine && !machinesMap.has(cm.machine.id)) {
                    machinesMap.set(cm.machine.id, cm.machine);
                }
            });
        }
    });
    // Convert the Map values to an array and give the length
    const contractMachineLength = Array.from(machinesMap.values()).length;

    if (!contract) {
        return (
            <Box className='table_row'>
                <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.title, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.company }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.machines }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.date }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.sites }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.auto_renew }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.visit_frequency }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.contract_number }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#EA5E00', width: '50px' }}><Iconify icon='ri:arrow-right-s-line' /></Box>
            </Box>
        );
    }

    return (
        <Box className='table_row' onClick={() => handleContractClick(contract.id)}>
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.title, maxWidth: columnWidth.title, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '5px' }}>
                    <Typography className='tableBodyTypography'>{contract.title} </Typography>
                    {(() => {
                        const renewDate = contract.contract_date[0]?.renew_date;
                        if (renewDate) {
                            const now = dayjs();
                            const renewDateMinus30 = dayjs(renewDate).subtract(30, 'day');
                            if (now.isAfter(renewDateMinus30) && now.isBefore(dayjs(renewDate))) {
                                return (
                                    <Tooltip title="Le contrat est sur le point d'être renouvelé automatiquement." placement="top">
                                        <span>
                                            <Iconify icon="material-symbols:warning-outline" className='contractMachine_gridview_warning_icon' />
                                        </span>
                                    </Tooltip>
                                );
                            }
                        }
                        return '';
                    })()}
                </Box>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.company, maxWidth: columnWidth.company }}>
                <Typography className='tableBodyTypography'> {contract.company.name}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.machines, maxWidth: columnWidth.machines }}>
                {contract.contract_date[0]?.contract_machine.length > 0 ?
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <Typography className='tableBodyTypography'>{contract.contract_date[0]?.contract_machine[0].machine.name}</Typography>
                        {contract.contract_date[0]?.contract_machine.length > 1 && (
                            <Typography className='machines_gridview_machine_metier_length' component="span">+{contractMachineLength - 1}</Typography>
                        )}
                    </Box>
                    :
                    <Typography className='tableBodyTypography'>N/A</Typography>
                }
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.date, maxWidth: columnWidth.date }}>
                <Typography className='tableBodyTypography'>
                    {FormatDate(contract?.firstPeriodStartDate)} - {contract?.lastPeriodEndDate ? FormatDate(contract?.lastPeriodEndDate) : 'Ouvert'}
                </Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.auto_renew, maxWidth: columnWidth.auto_renew }}>
                <ContractRenewStatus status={contract?.auto_renew} />
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.visit_frequency, maxWidth: columnWidth.visit_frequency }}>
                <Typography className='tableBodyTypography'>{contract.visit_count ? contract.visit_count + ' ' + contract.visit_frequency : 'N/A'}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.contract_number, maxWidth: columnWidth.contract_number }}>
                <Typography className='tableBodyTypography'>  {contract.contract_number || 'N/A'}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: '50px' }}><Iconify icon='ri:arrow-right-s-line' /></Box>
        </Box>
    );
};

export default ContractsListViewData;